import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=33e60afa&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=33e60afa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33e60afa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33e60afa')) {
      api.createRecord('33e60afa', component.options)
    } else {
      api.reload('33e60afa', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=33e60afa&scoped=true&", function () {
      api.rerender('33e60afa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-269j70cbrGQEr/JS/comp/SearchFilterTokens.vue"
export default component.exports